<script setup>
import { computed } from "vue";
import { useStore } from "vuex";

const store = useStore();
const isRTL = computed(() => store.state.argonConfig.isRTL);
const isNavFixed = computed(() => store.state.argonConfig.isNavFixed);

const props = defineProps({
  currentPage: {
    type: Array,
    default: () => [],
  },
  currentDirectory: {
    type: String,
    default: "",
  },
});

const formattedCurrentPage = computed(() => {
  const metaTitle = props.currentPage[2]?.meta?.title;
  const isFaqRoute = props.currentPage[0][0] === 'faq';
  
  return props.currentPage[0].map((cp) => {
    // Only replace numeric segment with meta title for FAQ routes
    if (isFaqRoute && /^\d+$/.test(cp) && metaTitle) {
      return metaTitle;
    }
    return cp.replace(/-/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
  });
})

const lastWordCurrPage = computed(() => {
  // For FAQ routes, don't use meta title for the main heading (it's already in breadcrumb)
  const isFaqRoute = props.currentPage[0][0] === 'faq';
  if (isFaqRoute) {
    return props.currentPage[1]; // Use route name instead
  }
  // Use route meta title if available, otherwise use route name
  const metaTitle = props.currentPage[2]?.meta?.title;
  return metaTitle || props.currentPage[1];
})

</script>
<template>
  <nav aria-label="breadcrumb">
    <ol class="px-0 pt-1 pb-0 mb-0 bg-transparent breadcrumb" :class="!isRTL && 'me-sm-6'">
      <li class="text-sm breadcrumb-item" :class="isRTL && 'ps-2'">
        <a :class="isNavFixed ? 'text-dark' : 'text-white'">
          <i class="ni ni-box-2"></i>
        </a>
      </li>
      <li class="text-sm breadcrumb-item" :class="isNavFixed ? 'text-dark' : 'text-white'">
        <a v-if="isRTL" class="opacity-8 ps-2" :class="isNavFixed ? 'text-dark' : 'text-white'" href="#" >لوحات القيادة</a>
        <a v-else :class="`${isNavFixed ? 'text-dark' : 'text-white'}`" href="#" >{{ props.currentDirectory }}</a>
      </li>
      <li v-for="(value, id) in formattedCurrentPage.slice(1, 3)" :key="id" class="text-sm breadcrumb-item active" :class="isNavFixed ? 'text-dark' : 'text-white'" aria-current="page">
        {{ value }}
      </li>
    </ol>
    <h6 class="mb-0 font-weight-bolder" :class="isNavFixed ? 'text-dark' : 'text-white'">
      {{ lastWordCurrPage }}
    </h6>
  </nav>
</template>
